import React, { useContext, useEffect, useState } from "react";
import { Table, Empty, Popover, Modal, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./styleCss.scss";
import { TemplateContext } from "../../../utils/template_context";
import { JuradosService } from "../../../api/Jurados/api-jurados";
import getStorageUser from "../../../middlewares/GetStorageUser";
import { ModalVerMasJurado } from "../../Admin/BancoJurados/ModalVerMasJurado";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { useEncrypt } from "../../../hooks/useEncrypt";
import { useNavigate } from "react-router";


// Instance JuradosService
const juriesServices = new JuradosService();
 
// @ts-ignore
export default function MisPostulacionesJurado(props: any) {
  const context = useContext(TemplateContext);
  const { decrypt, encrypt } = useEncrypt();
  const [matchScreen, setMatchScreen] = useState<any>("");
  const [user, setUser] = useState<any>({});
  const [totalInformacion, setTotalInformacion] = useState(0);
  const [miInformacion, setmiInformacion] = useState([]);
  const [loadingmiInformacion, setLoadingmiInformacion] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const navigate = useNavigate();

  interface PostulacionModel {
    id_postulacion: number;
    convocatoria_id: number;
    numero_documento_participante: number;
    nombre_propuesta: string;
    nombre_participante: string;
    jurados: Array<Object>;
    estado_jurado: boolean;
    fecha_creacion: string;
    tipo_participante: string;
    links: Array<Object>;
    nombre_convocatoria: string;
    categoria_linea_convocatoria: Array<Object>;
    fecha_apertura: string;
    fecha_actualizacion: string;
    particiapnte: Array<Object>;
    estado: string;
    documentos_generales: Array<Object>;
    documentos_tecnicos: Array<any>;
    documentos_administrativos: any;
    linea_convocatoria: number;
    radicado: string;
    pasos: {
      personales: boolean,
      categorias: boolean,
      administrativos: boolean,
      tecnicos: boolean,
      links: boolean
    };
  }

  const initialValuesPostulacionModel = {
    id_postulacion: 0,
    convocatoria_id: 0,
    numero_documento_participante: 0,
    nombre_propuesta: "",
    nombre_participante: "",
    jurados: [],
    estado_jurado: false,
    fecha_creacion: "",
    tipo_participante: "",
    links: [],
    nombre_convocatoria: "",
    categoria_linea_convocatoria: [],
    fecha_apertura: "",
    fecha_actualizacion: "",
    particiapnte: [],
    estado: "",
    documentos_generales: [],
    documentos_tecnicos: [],
    documentos_administrativos: [],
    linea_convocatoria: 0,
    radicado: "",
    pasos: {
      personales: true,
      categorias: false,
      administrativos: false,
      tecnicos: false,
      links: false
    }
  };

  const [postulacionEditar, setPostulacionEditar] = useState<PostulacionModel>(initialValuesPostulacionModel);
  const validateFormsCompleted = (datos) => {
    //Se resta uno debido a que los documentos evaluan a los tipos de participantes del 0 al 2 y no del 1 al 3 como al momento del registro
    setPostulacionEditar(datos);
    //setModalEditar(true);
  }



  const getUser = async () => {
    try {
      const user = getStorageUser()
      setUser(user);
    } catch (error) {
      console.log(error);
    }
  };
  const getJury = async () => {
    setLoadingmiInformacion(true);
    const jury = await juriesServices.getJuryByDocNumber(user.documento);
    if (jury.length > 0) {
      setTotalInformacion(jury.length);
      setmiInformacion(jury);
    } else {
      setTotalInformacion(0);
      setmiInformacion([]);
    }
    setLoadingmiInformacion(false);

  }
  useEffect(() => {
    if (user.documento) {
      getJury();
    }
  }, [user]);

  useEffect(() => {
    getUser();

    var mobileQuery = window.matchMedia("(max-width: 768px)");
    mediaQueryCheck(mobileQuery);
    mobileQuery.addEventListener("change", mediaQueryCheck);
    return () => {
      mobileQuery.removeEventListener("change", mediaQueryCheck);
    };
  }, [matchScreen]);


  function mediaQueryCheck(inputQuery: any) {
    if (inputQuery.matches) {
      setMatchScreen(true);
    } else {
      setMatchScreen(false);
    }
  }

  const handleOk2 = () => {
    setIsModalOpen2(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };

  const showEstadosFormulario = (datos) => {
    setPostulacionEditar(datos);
    return navigate('/usuario/estadosFormulario')
  };


  const guardar = async (datos?: any) => {
    try {
        await apiParticipantes.eliminarPostulacionRadicado(datos.radicado, datos.numero_documento);
      } catch (error) {
        console.log(error)
    }
    window.location.reload();
  }

  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },

    {
      title: "Nombre y apellido",
      width: 200,
      render: (datos: any) => {
        return (
          <>
            {datos.primer_nombre} {datos.segundo_nombre} {datos.primer_apellido} {datos.segundo_apellido}
          </>
        );
      },

    },
    {
      title: "Nro documento",
      width: 140,
      dataIndex: "numero_documento",
      key: "numero_documento",
    },
    {
      title: "Código",
      width: 120,
      dataIndex: "radicado",
      key: "radicado",
    },
    {
      title: "Fecha de creación",
      width: 100,
      render: (datos: any) => {
        return (
          <>
            <span>{datos.fecha_creacion}</span>
          </>
        );
      },
    },
    {
      title: "Modalidad",
      width: 120,
      render: (datos: any) => {
        // Verificar si areas_conocimientos es null
        if (!datos?.areas_conocimientos) {
          return <>Experto con título</>;
        }
        return (
          <>
            {datos?.areas_conocimientos.map(
              (conocimientos: any, index: number) => (
                <div key={index}>
                  {conocimientos?.tipo_conocimiento === 1
                    ? "Experto con título"
                    : conocimientos?.tipo_conocimiento === 2
                    ? "Experto sin título"
                    : ""}
                </div>
              )
            )}
          </>
        );
      },
    },
    {
      title: "Estado",
      width: 120,
      dataIndex: "estado",
      key: "estado",
      render: (statusValue: string, record: any, index: number) => {
        return (
          <>
            {statusValue === 'Sin verificar' ? (
              <div>
                <span>Inscrito sin revisar</span>
              </div>
            ) : (
              <div>
                <span>{statusValue}</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Área",
      width: 169,
      render: (datos: any) => {
        return <div>{datos.area != null ? datos.area : 'Este jurado no tiene areas'}</div>
      },
    },
    {
      title: "Categorías",
      width: 169,
      ellipsize: true,
      render: (datos: any) => {
        // Si areas_conocimientos es null, utiliza categorias_area
        const categorias = datos?.areas_conocimientos
          ? datos?.areas_conocimientos.flatMap((conocimientos: any) =>
              conocimientos?.areas_conocimientos.map(
                (datos_conocimientos: any) => datos_conocimientos?.nombre
              )
            )
          : JSON.parse(datos?.categorias_area || "[]").map(
              (categoria: any) => categoria?.nombre
            );
        const content = (
          <ul>
            {categorias.map((nombre: string, index: number) => (
              <li
                key={index}
                className="font-family-Monserrat-Regular font-size-11px"
              >
                {nombre}
              </li>
            ))}
          </ul>
        );

        const firstCategory = categorias[0] || "Sin categoría";

        return (
          <>
            <Popover content={content} title="Categorías">
              {firstCategory.length > 27
                ? `${firstCategory.substring(0, 24)}...`
                : firstCategory}
            </Popover>
          </>
        );
      },
    },

    {
      title: () => (
        <div className="row">
          <div className="col-12 justify-content-center">
            Acciones
          </div>
        </div>
      ),
      width: 90,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <>
          <div className="col-12 justify-content-center">
            <div>
              <a className="button-azul-ghost" onClick={() =>
                openModalVerMas(datos)
              }>Ver más</a>
            </div>
          </div>
            {/*
            datos?.estado !== "Anulado" &&
            <div className="col-12 justify-content-center">
              <div>
                <a className="button-azul-ghost"
                  onClick={() => {
                    console.log(datos)
                    showModal2();
                    validateFormsCompleted(datos);
                  }}>
                    Anular
                </a>
              </div>
            </div>
            */}
            {
            datos?.estado === "Anulado" &&
            <div className="col-12 justify-content-center">
              <div>
                <a className="button-azul-ghost"
                  onClick={() => {
                    console.log(datos)
                    showEstadosFormulario(datos)
                  }}>
                    Editar
                </a>
              </div>
            </div>
            }
        </>
      ),
    },
  ];

  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  };

  const [idJurado, setIdJurado] = useState(0);
  const [radicado, setRadicado] = useState('');
  const [estado, setEstado] = useState();
  const [idPostulacion, setIdPostulacion] = useState(0)
  const [observaciones, setObservaciones] = useState();
  const [areaPrincipal, setAreaPrincipal] = useState('')
  const [numero_documento, setNumero_documento] = useState('');

  const openModalVerMas = (jurado: any) => {
    setAreaPrincipal(jurado.area);
    setIdJurado(jurado.id_jurado);
    setOpenModal(true);
    setRadicado(jurado.radicado)
    setObservaciones(jurado.observaciones);
    setEstado(jurado.status)
    setIdPostulacion(jurado.id_postulacion)
    setNumero_documento(jurado.numero_documento)
  }

  return (
    <div className="row">
      <div className="col-12">
        <Table
          style={{ borderTop: "1px solid #C4C4C4" }}
          locale={{ emptyText: <Empty description="No hay información para mostrar" style={{ padding: "50px" }} /> }}
          pagination={false}
          dataSource={miInformacion}
          columns={columns}
          size="small"
          bordered={false}
          loading={loadingmiInformacion}
        />
      </div>
      {openModal &&
        <ModalVerMasJurado
          openModal={openModal}
          setOpenModal={setOpenModal}
          idJurado={idJurado}
          radicado={radicado}
          observaciones={observaciones}
          estado={estado}
          tipoPostulacion={'bancojurados'}
          setEstado={setEstado}
          idPostulacion={idPostulacion}
          obtenerJurados={getJury}
          areaPrincipal={areaPrincipal}
          docJurado={numero_documento}
        />
      }
      <Modal
          style={{ top: 120, zIndex: 3, background: "transparent" }}
          visible={isModalOpen2}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closeIcon="X"
          onOk={handleOk2}
          onCancel={handleCancel2}
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa modal-formularios-completar"
        >
          {
            postulacionEditar ?
              <div>
                <div className="row-shadow">
                  <div className="row">
                    <div className="text-center col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_azul">
                      ¿Desea anular la postulación con radicado: {postulacionEditar.radicado}?
                    </div>
                    <div className="text-center col-12">
                      <Button className="button-gray-ghost" onClick={handleCancel2}>
                        CANCELAR
                      </Button>
                      <Button className="button-azul-radius" onClick={() => {
                        guardar(postulacionEditar);
                        handleOk2;
                        }}>
                        ACEPTAR
                      </Button>
                      {console.log(miInformacion)}
                    </div>
                  </div>
                </div>
              </div>
              :
              <p>No se pudo cargar esta convocatoria</p>
          }
        </Modal>
    </div>
  );
}
